export default {
  EVENT_SETTINGS_UPDATED: "Les paramètres de l'événement ont été mis à jour avec succès!",
  DAILY_REPORTS_ENABLED: 'Rapports quotidiens activés',
  EVENT_SETTINGS: "Paramètres d'événement",
  ARCHIVAL_DAYS: 'Journées des archives',
  EVENT_ARCHIVAL_DATE: "L'événement sera archivé sur "
}
